import React from "react";
import HeaderCities from "../components/HeaderCities";
import AtticCleanoutFAQs from "../components/AtticCleanoutFAQs";
import ServicesArea from "../components/ServicesArea";
import UpperFooter from "../components/UpperFooter";
import "../assets/css/services.css";

function Attic() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Need attic junk gone? Junk Droid offers fast, reliable attic cleanout services. We handle the heavy lifting for a stress-free, clutter-free space!"
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/Attic-Cleanout-min.webp"
          type="image/webp"
        />
        <link
          rel="canonical"
          href="https://junkdroid.com/services/attic-cleanout/"
        />

        <title>Attic Cleanout | Fast & Reliable | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Services</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Attic Cleanout
                    </li>
                  </ol>
                </nav>
                <h1>
                  Attic Cleanout <span>Made Easy</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img
                    src="/assets/img/Attic-Cleanout-min.webp"
                    alt="Attic Cleanout"
                  />
                </div>
                <p>
                  Need to clear out your attic? Junk Droid’s attic cleanout
                  service makes junk removal easy and stress-free. We handle the
                  heavy lifting so you can enjoy a clutter-free space!
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="tel:4085397261">
                      <button type="button" className="btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>{" "}
                        &nbsp; CALL NOW
                      </button>
                    </a>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <img
                  src="/assets/img/Attic-Cleanout-min.webp"
                  alt="Attic Cleanout"
                />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Hero Section End HERE =========================  */}
        {/* ================== First  Section Start HERE =========================  */}
        <hr />
        <div className="container-fluid overview-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="major-heading">
                  Affordable Attic <span>Cleanout Services</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Clearing out your attic can feel like a daunting task, but our
                  affordable attic cleanout services are here to help. Whether
                  you’re preparing for a move, decluttering, or just reclaiming
                  your attic space, we specialize in making the process quick,
                  efficient, and stress-free. From old furniture, unwanted
                  items, boxes of memories to holiday decorations and general
                  junk, we handle it all so you don’t have to.
                </p>
                <p className="service-description">
                  Our attic cleanout service is here to make your life easier.
                  We collaborate with you to understand your specific needs,
                  develop a tailored plan, and leave your attic spotless and
                  well-organized. We also focus on environmentally responsible
                  disposal, so you can feel confident in your decision.
                </p>
                {/* ============ */}
                <h3>
                  Why Choose Our
                  <span className="ms-3">Attic Cleanout Services?</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Experienced Professionals: </span>&nbsp;Our team of
                    junk removal experts specializes in attic cleanouts,
                    ensuring a great experience every time.
                  </li>
                  <li>
                    <span>Eco-Friendly Disposal:</span>&nbsp;We recycle and
                    donate whenever possible, keeping dirty attics clean and
                    clutter-free.
                  </li>
                  <li>
                    <span>Fast and Reliable: </span>&nbsp;We offer flexible
                    scheduling, including same-day service to meet your needs.
                  </li>
                </p>
                {/* ============ */}
                <h3>
                  How It
                  <span className="ms-3">Works</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Schedule Your Free Quote:</span>&nbsp;Pick a time that
                    works for you, including same-day service.
                  </li>
                  <li>
                    <span>Get a Free Quote:</span>&nbsp;Get a no-obligation
                    attic cleanout estimate.
                  </li>
                  <li>
                    <span>We Handle the Heavy Lifting:</span>&nbsp;Our team
                    arrives fully equipped to remove all junk and debris from
                    your attic.
                  </li>
                  <li>
                    <span>Payment Made Easy:</span>&nbsp;Pay after the job is
                    done using cash, debit, credit, check, or Zelle.
                  </li>
                  <li>
                    <span> Eco-Friendly Disposal:</span>&nbsp;We donate usable
                    items to local charities and responsibly recycle the rest.
                  </li>
                </p>
                {/* ===================================================================================0 */}
                <h3>
                  Service
                  <span className="ms-3">Area</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>We proudly serve homes and properties in:</p>
                {/* ===================================================================================0 */}
                <ServicesArea />
                <div className="row">
                  <div className="col-md-12 overview-sec service-desc">
                    <h3 className="pt-0">
                      Book Now for a <span>Stress-Free Attic Cleanout!</span>
                    </h3>
                    <div className="sliderline-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={64}
                        height={4}
                        viewBox="0 0 64 4"
                        fill="none"
                      >
                        <path
                          d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                          fill="#60BDFF"
                        />
                      </svg>
                    </div>
                    <p>
                      Don’t let attic clutter pile up. Let our professional
                      cleanout team do the heavy lifting so you can enjoy a
                      clean, organized space. Contact us today for a free quote!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ================== First  Section End HERE =========================  */}
        {/* ================= What We Take Section Start Here ================= */}
        <div className="container-fluid more-detail-sec we-take-sec">
          <div className="container junk-container">
            <div className="row">
              <div className="col-md-12">
                <h2>What We Remove</h2>
                <div className="line-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>Our comprehensive services include:</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card bbq-card-sec bulkey-sec">
                  <h4>Bulky Items & Furniture </h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Old couches</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>desks</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>cabinets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>bed frames</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>storage unit clutter</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card">
                  <h4>Household Items</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Holiday decorations</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>toys</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>clothing</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>rugs</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>sports equipment</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card junks-cards">
                  <h4>Miscellaneous Junk </h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Packing materials</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>broken appliances</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>old luggage</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>cardboard boxes</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card junks-card-sec">
                  <h4>Hazardous Materials</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Old insulation</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>rodent droppings</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>pest infestation debris</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>structural damage remains</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card debris-card-sec">
                  <h4>Electronics & Construction Debris</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>TVs</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>computers</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>drywall scraps</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>damaged insulation</span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ===================== What We Take Section End Here ================ */}

        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Attic Cleanout <span>FAQs</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              <AtticCleanoutFAQs />
            </div>
          </div>
        </div>
        <UpperFooter />
      </>
    </div>
  );
}

export default Attic;
